'use client';

import { useRouter } from '@bprogress/next/app';
import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useRef } from 'react';

import { DEVICE_UUID } from '../constants';

const TIMEOUT_REFRESH = 100;
const MAX_RETRY_CHECK = 10;

interface ScriptMindboxProps {
  endpointId?: string;
}

export const ScriptMindbox = ({ endpointId }: ScriptMindboxProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const refRetryCheck = useRef(0);

  useEffect(() => {
    window.PopMechanic?.update?.();
  }, [pathname, searchParams]);

  const checkRefresh = () => {
    if (refRetryCheck.current > MAX_RETRY_CHECK) {
      // eslint-disable-next-line no-console
      console.error('Mindbox device UUID not found');
      // TODO: sentry push
      return;
    }
    const isCreated = document.cookie.includes(DEVICE_UUID);
    if (isCreated && refRetryCheck.current === 0) {
      return;
    }

    if (isCreated) {
      router.refresh();
    } else {
      setTimeout(() => {
        refRetryCheck.current = refRetryCheck.current + 1;
        checkRefresh();
      }, TIMEOUT_REFRESH);
    }
  };

  const handleLoad = () => {
    window.PopMechanic = { watchLocation: false };
    window.mindbox =
      window.mindbox ||
      function (...args: unknown[]) {
        window.mindbox.queue.push(args);
      };
    window.mindbox.queue = window.mindbox.queue || [];
    window.mindbox('create', {
      endpointId,
      cookieSettings: {
        sameSite: 'none',
        secure: process.env.NODE_ENV === 'production'
      }
    });
    checkRefresh();
  };

  return (
    <Script
      src="https://api.mindbox.ru/scripts/v1/tracker.js"
      async
      onLoad={handleLoad}
    />
  );
};
